import { formValues } from 'redux-form';
import Description from 'common/components/rip/InvestorProfile/ProfileDescription';

const ProfileDescription = formValues({
    investorProfile: 'data.profile',
})(Description);

export default ProfileDescription;
